import { useState } from 'react';
import type { ClubTheme } from './themes';
import { useReact } from './queries';

interface ReactionBarProps {
  clubId: string;
  postId: string;
  reactions: Record<string, number>;
  theme: ClubTheme;
  onReacted?: () => void;
}

export default function ReactionBar({ clubId, postId, reactions, theme, onReacted }: ReactionBarProps) {
  const [showPicker, setShowPicker] = useState(false);
  const react = useReact(clubId, postId);

  const handleReact = (emoji: string) => {
    setShowPicker(false);
    react.mutate(emoji, {
      onSuccess: () => onReacted?.(),
    });
  };

  const entries = Object.entries(reactions).sort((a, b) => b[1] - a[1]);

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {entries.map(([emoji, count]) => (
        <button
          key={emoji}
          type="button"
          onClick={() => handleReact(emoji)}
          className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs transition-colors"
          style={{
            backgroundColor: `${theme.colors.primary}18`,
            color: theme.colors.text,
          }}
        >
          <span>{emoji}</span>
          <span className="font-medium">{count}</span>
        </button>
      ))}

      <div className="relative">
        <button
          type="button"
          onClick={() => setShowPicker(!showPicker)}
          className="inline-flex items-center rounded-full px-2 py-0.5 text-xs transition-opacity hover:opacity-80"
          style={{ color: theme.colors.muted }}
        >
          +
        </button>

        {showPicker && (
          <div
            className="absolute bottom-full left-0 mb-1 flex gap-1 rounded-xl p-1.5 shadow-lg z-10"
            style={{ backgroundColor: theme.colors.surface, border: `1px solid ${theme.colors.muted}30` }}
          >
            {theme.defaultEmojis.map((emoji) => (
              <button
                key={emoji}
                type="button"
                onClick={() => handleReact(emoji)}
                className="rounded-lg p-1 text-base hover:scale-110 transition-transform"
              >
                {emoji}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
